class SampaBrandSlider extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready === 'true') return;
    this.dataset.ready = 'true';
    this.track = this.querySelector('[data-card-track]');
    this.items = this.track ? Array.from(this.track.children) : [];
    this.current = this.querySelector('[data-card-current]');
    if (!this.track || this.items.length < 2) return;

    this.autoplayEnabled = this.dataset.autoplay === 'true';
    this.autoplaySpeed = Math.max(Number.parseInt(this.dataset.autoplaySpeed, 10) || 5000, 1000);
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.eventController = new AbortController();
    const listenerOptions = { signal: this.eventController.signal };

    this.querySelector('[data-card-previous]')?.addEventListener('click', () => {
      this.move(-1);
      this.restartAutoplay();
    }, listenerOptions);
    this.querySelector('[data-card-next]')?.addEventListener('click', () => {
      this.move(1);
      this.restartAutoplay();
    }, listenerOptions);
    this.track.addEventListener('scroll', () => this.updateCurrent(), { passive: true, signal: this.eventController.signal });
    this.addEventListener('mouseenter', () => this.stopAutoplay(), listenerOptions);
    this.addEventListener('mouseleave', () => this.startAutoplay(), listenerOptions);
    this.addEventListener('focusin', () => this.stopAutoplay(), listenerOptions);
    this.addEventListener('focusout', (event) => {
      if (!this.contains(event.relatedTarget)) this.startAutoplay();
    }, listenerOptions);
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) this.stopAutoplay();
      else this.startAutoplay();
    }, listenerOptions);

    this.updateCurrent();
    this.startAutoplay();
  }

  disconnectedCallback() {
    this.stopAutoplay();
    this.eventController?.abort();
    this.dataset.ready = 'false';
  }

  step() {
    const styles = window.getComputedStyle(this.track);
    return this.items[0].getBoundingClientRect().width + (Number.parseFloat(styles.gap) || 0);
  }

  move(direction) {
    const step = this.step();
    const maximum = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
    let target;

    if (direction > 0 && this.track.scrollLeft >= maximum - 1) target = 0;
    else if (direction < 0 && this.track.scrollLeft <= 1) target = maximum;
    else target = Math.min(Math.max(this.track.scrollLeft + (step * direction), 0), maximum);

    this.track.scrollTo({ left: target, behavior: 'smooth' });
  }

  updateCurrent() {
    const step = this.step();
    const index = step > 0 ? Math.round(this.track.scrollLeft / step) : 0;
    if (this.current) this.current.textContent = String(Math.min(index + 1, this.items.length));
  }

  startAutoplay() {
    if (!this.autoplayEnabled || this.reducedMotion || this.track.scrollWidth <= this.track.clientWidth + 1 || document.hidden || this.matches(':hover') || this.contains(document.activeElement)) return;
    this.stopAutoplay();
    this.autoplayTimer = window.setInterval(() => this.move(1), this.autoplaySpeed);
  }

  stopAutoplay() {
    window.clearInterval(this.autoplayTimer);
    this.autoplayTimer = null;
  }

  restartAutoplay() {
    this.stopAutoplay();
    this.startAutoplay();
  }
}
if (!customElements.get('sampa-brand-slider')) customElements.define('sampa-brand-slider', SampaBrandSlider);
